<ll-titulo>Lista escalas globales</ll-titulo>
<ll-toolnavbar>
    <escala-globales-toolnavbar></escala-globales-toolnavbar>
</ll-toolnavbar>

<escala-globales-list></escala-globales-list>
